import { render, staticRenderFns } from "./CarInformations.vue?vue&type=template&id=40d127c6&scoped=true"
import script from "./CarInformations.vue?vue&type=script&lang=js"
export * from "./CarInformations.vue?vue&type=script&lang=js"
import style0 from "./CarInformations.vue?vue&type=style&index=0&id=40d127c6&prod&lang=scss"
import style1 from "./CarInformations.vue?vue&type=style&index=1&id=40d127c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d127c6",
  null
  
)

export default component.exports